import { apiCaller } from '@/redux/query';
import RenderRouter from '@/routes';
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import { useEffect, useMemo } from 'react';

function App() {
  // const isSkip = useSelector(isSkipApiSelector);
  const { data: dataSetting } = apiCaller.useGeneralSettingsQuery();

  const instanceId = useMemo(() => {
    return dataSetting?.data?.instanceId;
  }, [dataSetting?.data?.instanceId]);

  useEffect(() => {
    if (!instanceId) return;
    const timer = setTimeout(() => {
      var crisp = document.createElement('script');
      crisp.setAttribute('src', `${process.env.REACT_APP_API_END_POINT}public/script/plugin.js?instanceId=${instanceId}`);
      crisp.setAttribute('id', 'omega-chat-crisp');
      crisp.setAttribute('instanceId', instanceId);
      crisp.appendChild(document.createTextNode(``));
      document.body.appendChild(crisp);
    }, 1500);
    return () => {
      clearTimeout(timer);
    };
  }, [instanceId]);

  return (
    <AppProvider i18n={enTranslations}>
      <RenderRouter />
    </AppProvider>
  );
}

export default App;
